module.exports = __webpack_public_path__ + "static/media/consultancy.760418ff.png";